import { render, staticRenderFns } from "./m-certificate-public.vue?vue&type=template&id=410981d8&"
import script from "./m-certificate-public.vue?vue&type=script&lang=js&"
export * from "./m-certificate-public.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports